import {DownloadWrapper, Wrapper} from '@/components/pages/tools/bulk_user_upload/BulkUserUploadForm.styles';
import FileInput from 'patient-ping-remedy/packages/file-input';
import Button, {StyleType} from 'patient-ping-remedy/packages/button';
import {SmallTypography} from 'patient-ping-remedy/packages/typography';
import InfoIconTooltip from '@common/InfoIconTooltip';
import React, {ChangeEvent} from 'react';
import {GenericObject} from '@/hooks/useForm';
import FileHelpers from '@/helpers/file_helpers';

type Props = {
  form: GenericObject;
  handleChange(e: ChangeEvent | null, name: string, value: any): void;
}

export default function BulkUserUploadForm({ form, handleChange }: Props) {
  const handleDownload = () => {
    FileHelpers.downloadFile('/templates/bulk-user-upload-template.csv', 'bulk-user-upload-template.csv');
  };

  return (
    <Wrapper>
      <FileInput
        acceptedFiles=".csv"
        label="Select a file"
        onChange={(files: File[]) => handleChange(null, 'file', files)}
        value={form.file?.value ?? []}
        buttonText="Browse"
        buttonType={StyleType.SECONDARY}
        error={form.file?.valid.message}
      />
      <DownloadWrapper>
        <span>
          <SmallTypography>Download CSV Template </SmallTypography>
          <InfoIconTooltip text="This is an example file with the format which is expected by the Bulk User Upload tool." />
        </span>
        <Button styleType={StyleType.TERTIARY} onClick={handleDownload}>Download Template</Button>
      </DownloadWrapper>
    </Wrapper>
  );
}
